module.exports = __webpack_public_path__ + "static/media/remove_prod.153a33e3.svg";